import { ModalMessage } from '@zorro/design-system/v2/ModalMessage';
import { useIdempotencyKey, useMonolithMutation } from '@zorro/web/ui-utils';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit?: () => void;
  onboardingPeriodId?: string;
};

export const DeleteEnrollmentRecord = ({
  isOpen,
  onClose,
  onSubmit,
  onboardingPeriodId,
}: Props) => {
  const idempotencyKey = useIdempotencyKey();
  const { tryMutate: mutateOnboardingPeriodDelete } = useMonolithMutation({
    successMessage: 'Deleted enrollment record successfully.',
    method: 'onboardingPeriodsControllerDelete',
  });

  if (!onboardingPeriodId) {
    return null;
  }

  const handleEnrollmentDelete = async () => {
    const mutationResult = await mutateOnboardingPeriodDelete([
      onboardingPeriodId,
      idempotencyKey.get(),
    ]);

    if (mutationResult.isOk()) {
      onSubmit?.();
    }

    onClose();
  };

  return (
    <ModalMessage
      isOpen={isOpen}
      onClose={onClose}
      variant="negative"
      title="Delete enrollment record?"
      description="Are you sure you want to delete this enrollment record? This action cannot be undone"
      primaryLabel="Delete enrollment"
      onPrimaryAction={handleEnrollmentDelete}
      secondaryLabel="Cancel"
      onSecondaryAction={onClose}
    />
  );
};
